import { Route, Routes } from "react-router-dom"
import MenusListing from "./pages/MenusListing"

export const MenuRouter = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<MenusListing />} />
      </Routes>
    </div>
  )
}
